module.exports = __webpack_public_path__ + "img/2-February.7b376fb8.jpg";